import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import type { ActividadPrograma } from "@/interfaces/actividadPrograma.interface";

interface Props {
  data: ActividadPrograma;
}

export function DetalleActividadPrograma({ data }: Props) {
  return (
    <Card className="w-full max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle>{data.nombre}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        <div className="space-y-2 text-sm text-muted-foreground">
          <p>
            <strong>ID:</strong> {data.id}
          </p>
          <p>
            <strong>Programa:</strong> {data.idPrograma}
          </p>
          <p>
            <strong>Nombre:</strong> {data.nombre}
          </p>
          <p>
            <strong>Archivo Limpio:</strong> {typeof data.archivoLimpio === "object" && data.archivoLimpio !== null ? `${data.archivoLimpio.nombre} (${data.archivoLimpio.url})` : "N/A"}
          </p>
          <p>
            <strong>Límite de Intentos:</strong> {data.limiteIntentos}
          </p>
          <p>
            <strong>Fecha Inicio:</strong>{" "}
            {data.fechaInicio
              ? new Date(data.fechaInicio).toLocaleDateString()
              : "N/A"}
          </p>
          <p>
            <strong>Fecha Fin:</strong>{" "}
            {data.fechaFin
              ? new Date(data.fechaFin).toLocaleDateString()
              : "N/A"}
          </p>
          <p>
            <strong>Creado El:</strong>{" "}
            {new Date(data.creadoEl).toLocaleDateString()}
          </p>
          <p>
            <strong>Actualizado El:</strong>{" "}
            {new Date(data.actualizadoEl).toLocaleDateString()}
          </p>
          <p>
            <strong>Creado Por:</strong> {data.creadoPor}
          </p>
          <p>
            <strong>Actualizado Por:</strong> {data.actualizadoPor}
          </p>
          <p>
            <strong>Activo:</strong> {data.isActivo ? "Sí" : "No"}
          </p>
          <p>
            <strong>Oculto:</strong> {data.isOculto ? "Sí" : "No"}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
